import { reviewFact, reviewText, statusFromRuntime } from '../../runtime/review-contribution-helpers'
import {
    uniqueSubstanceCount,
} from './compliance-requirements'
import { buildComplianceInformationV2Requirements } from './compliance-information-v2-validation'
import { blockingReasons } from './requirement-checks'

const createComplianceInformationV2ReviewContribution = ({ context, step }) => {
    const complianceState = context.complianceInformation || {}
    const requirements = buildComplianceInformationV2Requirements(context, step.settings)
    const completedCount = requirements
        .filter(requirement => requirement.status === 'complete').length
    const needsInputCount = requirements.length - completedCount
    const strict = step.settings.requireCompleteInformation !== false
    const checks = requirements.reduce((result, requirement) => {
        const seenReasons = new Set()
        const title = requirement.list && requirement.list.title
            ? requirement.list.title
            : `Requirement ${requirement.id}`
        const legislationLabels = (requirement.legislations || [])
            .map(legislation => legislation.title || legislation.name || legislation.key)
            .filter(Boolean)

        return result.concat(blockingReasons(requirement.checks)
            .filter(reason => {
                const key = `${reason.id}|${reason.messageKey || reason.fallbackMessage}`
                if (seenReasons.has(key)) {
                    return false
                }
                seenReasons.add(key)
                return true
            })
            .map(reason => ({
                id: `${requirement.id}-${reason.id}`,
                status: 'failed',
                severity: strict ? 'blocking' : 'advisory',
                message: reviewText(reason.messageKey, reason.fallbackMessage),
                group: {
                    id: String(requirement.id),
                    title: reviewText(null, title),
                    subtitle: legislationLabels.length > 0
                        ? reviewText(null, legislationLabels.join(', '))
                        : null,
                },
            })))
    }, [])
    let status = statusFromRuntime(step)

    if (complianceState.loaded !== true) {
        status = 'pending'
    } else if (needsInputCount > 0) {
        status = strict ? 'blocked' : 'attention'
    } else if (status !== 'pending') {
        status = 'complete'
    }

    return {
        status,
        summary: needsInputCount > 0
            ? reviewText(
                'Page(ReceivedRequest):Component(WorkflowReview):requirements-need-input',
                `${needsInputCount} requirement(s) need attention`,
                { count: needsInputCount },
            )
            : reviewText(
                'Page(ReceivedRequest):Component(WorkflowReview):compliance-complete',
                'All compliance requirements are complete',
            ),
        facts: [
            reviewFact(
                'requirements-completed',
                reviewText(
                    'Page(ReceivedRequest):Component(ComplianceInformation):requirements-completed',
                    'Requirements completed',
                ),
                completedCount,
            ),
            reviewFact(
                'requirements-need-input',
                reviewText(
                    'Page(ReceivedRequest):Component(ComplianceInformation):requirements-need-input',
                    'Requirements needing input',
                ),
                needsInputCount,
            ),
            reviewFact(
                'substances',
                reviewText(
                    'Page(ReceivedRequest):Component(ComplianceInformation):substances-identified',
                    'Substances identified',
                ),
                uniqueSubstanceCount(requirements),
            ),
        ],
        checks,
    }
}

export { createComplianceInformationV2ReviewContribution }
export default createComplianceInformationV2ReviewContribution
